import React from "react";

type Props = React.PropsWithChildren<
	React.LabelHTMLAttributes<HTMLLabelElement>
>;

/**
 * Label コンポーネント
 * @returns {JSX.Element} Label コンポーネント
 */
export default function Label(props: Props) {
	const { children, ...rest } = props;

	return <label {...rest}>{children}</label>;
}
